<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10A1M2r/tc-custom/9781429988032.jpg?1732053866143" alt="This image is the cover for the book King James Conspiracy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King James Conspiracy
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The turning of the wheel by the tilling of the wheat. <br/><br/></i>With these cryptic words, a conspiracy is set into motion that threatens the new translation of the Bible ordered by King James I, and the lives of the scholars working on it. <br/><br/>In 1605, in Cambridge England, a group of scholars brought together to create a definitive English translation of the Bible finds one of its members savagely murdered by unknown hands. Deacon Marbury, the man in charge of this group, seeks outside help to find the murderer, to protect the innocents and their work. But the people who offer to help are not who they claim to be and the man they send to Marbury—Brother Timon—has a secret past, much blood on his hands, and is an agent for those forces that wish to halt the translation itself. <br/><br/>But as the hidden killer continues his gruesome work, the body count among the scholars continues to rise. Brother Timon is torn between his loyalties and believes an even greater crisis looms as ancient and alarming secrets are revealed—secrets dating back to the earliest days of Christianity that threaten the most basic of its closely held beliefs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phillip DePoy
      </h2>
      
      <p class="authorDescription body article"><P>PHILIP DEPOY is the award-winning author of many novels and plays. He is the director of the theatre program at Clayton State University. He lives in Decatur, Georgia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04832dda